var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.editMode)?_c('SelectDropdown',{attrs:{"label":_vm.label,"options":_vm.glAccounts.map((item) => ({
                id: item.id,
                title: `${item.account_number}: ${item.account_name}`,
            })),"multiple":false,"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}}}):_c('div',[_c('InfoListItem',{attrs:{"title":_vm.label,"value":_vm.foundGlAccountTitle}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }